import { Mail, Phone, Instagram, MessageCircle } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/components/PageHeader";
import { OwnerForm } from "@/components/OwnerForm";
import { useSettings } from "@/context/SettingsContext";
import { useT } from "@/context/LanguageContext";

export default function Contact() {
  const s = useSettings();
  const t = useT().contact;
  return (
    <>
      <Seo title="Contact" description="Contactez Riviera Host Collection — conciergerie premium à Cannes, Le Cannet et sur la Côte d’Azur." path="/contact" />
      <PageHeader overline={t.overline} title={t.title} />
      <section className="py-20 sm:py-28 max-w-[1500px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-3 gap-12 lg:gap-20">
          <Reveal>
            <h2 className="font-serif text-3xl mb-2">Riviera Host Collection</h2>
            <p className="text-ink/60 mb-10">{s.city}</p>
            <ul className="space-y-5">
              <li><a href={`mailto:${s.email}`} data-testid="contact-email" className="flex items-center gap-3 hover:text-gold transition-colors"><Mail size={18} className="text-gold" /> {s.email}</a></li>
              {s.phone && <li><a href={`tel:${s.phone}`} data-testid="contact-phone" className="flex items-center gap-3 hover:text-gold transition-colors"><Phone size={18} className="text-gold" /> {s.phone}</a></li>}
              <li><a href={s.instagram} target="_blank" rel="noreferrer" data-testid="contact-instagram" className="flex items-center gap-3 hover:text-gold transition-colors"><Instagram size={18} className="text-gold" /> Instagram</a></li>
              {s.whatsapp && <li><a href={s.whatsapp} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="flex items-center gap-3 hover:text-gold transition-colors"><MessageCircle size={18} className="text-gold" /> WhatsApp</a></li>}
            </ul>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-2"><p className="overline text-ink/50 mb-8">{t.write}</p><OwnerForm compact /></Reveal>
        </div>
      </section>
    </>
  );
}
